import { useEffect, useState } from "react";

import { fixTimeFormat } from "../../utils/dates";
import { SessionDiv } from "./InitialLayoutStyles";
import { ENVIRONMENT_NAMES, getEnvironment } from "../../utils/deploymentUtils";
const secondInMs = 1000;

function parseJwt(token: any) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("")
  );
  return JSON.parse(jsonPayload);
}

export function getExpirationDate(sessionData: any) {
  const date = new Date(0);
  date.setSeconds(sessionData.exp);
  return date;
}

export function getExpirationSecs(sessionData: any) {
  const diffInMs = sessionData.exp * secondInMs - Date.now();
  return diffInMs / secondInMs;
}

function formatRemainingTime(diffInSeconds: any) {
  const date = new Date(0, 0);
  date.setSeconds(diffInSeconds);
  const hours = fixTimeFormat(date.getHours());
  const minutes = fixTimeFormat(date.getMinutes());
  const seconds = fixTimeFormat(date.getSeconds());
  return `${hours}:${minutes}:${seconds}`;
}

function getMaxSessionSeconds() {
  const token = localStorage.getItem("accessToken");
  if (token) {
    const sessionData =
      getEnvironment() === ENVIRONMENT_NAMES.LOCAL
        ? { exp: sessionStorage.getItem("exp") }
        : parseJwt(token);
    return getExpirationSecs(sessionData);
  } else {
    return -1;
  }
}

export function useSessionTimer({ onLogout }) {
  const [expirationTime, setExpirationTime] = useState(getMaxSessionSeconds());
  useEffect(() => {
    const expireSession = () => {
      const actExpirationTime: any = sessionStorage.getItem("exp");
      if (actExpirationTime - Date.now() / secondInMs < 1) {
        sessionStorage.removeItem("sessionExpired");
        onLogout();
      } else {
        setExpirationTime(getMaxSessionSeconds());
      }
    };
    if (expirationTime > -1) {
      const timeout = setTimeout(expireSession, expirationTime * secondInMs);
      return () => clearTimeout(timeout);
    }
  }, [expirationTime, onLogout]);
  return [expirationTime, setExpirationTime];
}

export function SessionTimer() {
  const [seconds, setSeconds] = useState(-1);
  useEffect(() => {
    setSeconds(getMaxSessionSeconds());
    const interval = setInterval(() => {
      setSeconds(getMaxSessionSeconds());
    }, secondInMs);
    return () => clearInterval(interval);
  }, []);
  return (
    <SessionDiv>
      <div> Tiempo restante de sesión </div>
      <div> {formatRemainingTime(seconds)} </div>
    </SessionDiv>
  );
}
